import React from "react";
import find from "lodash/find";
import get from "lodash/get";
import map from "lodash/map";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import { Button, Icon, Layout, message, Modal, Table } from "antd";

import classes from "./DocumentsEtmfSchema.css";

import isAuthenticated from "../../utils/isAuthenticated";

import { logout } from "../../reducers/user/actions";
import { getCreateEtmfDocument } from "../../reducers/user/selectors";
import {
  etmfDocumentSchemaDownload,
  etmfDocumentSchemaGet,
} from "../../api/requests";
import { withNamespaces } from "react-i18next";
import DocumentEtmfSchemaUpload from "./DocumentEtmfSchemaUpload";

const { Content } = Layout;

class DocumentsEtmfSchema extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      etmfSchema: [],
      isLoading: false,
      loadingSchema: false,
      isUploadModalOpen: false,
    };
  }

  async componentDidMount() {
    this.etmfDocumentSchemaGet();
  }

  etmfDocumentSchemaGet = async () => {
    this.setState({ isLoading: true, etmfSchema: [] });
    const {
      data: { schema: etmfData },
    } = await etmfDocumentSchemaGet();

    const result = [];
    const etmfSchema = forEach(etmfData, (category) => {
      result.push({
        id: category.code,
        category: {
          name: category.name,
          type: category.type,
          code: category.code,
        },
        limit_visibility_types: category.limit_visibility_types,
      });

      forEach(category.sub_categories, (subCategory) => {
        result.push({
          id: subCategory.code,
          subCategory: {
            name: subCategory.name,
            type: subCategory.type,
            code: subCategory.code,
          },
          limit_visibility_types: subCategory.limit_visibility_types,
        });

        forEach(subCategory.content_types, (contentTypes) => {
          result.push({
            id: contentTypes.code,
            name: contentTypes.name,
            code: contentTypes.code,
            type: contentTypes.type,
            reliesOnDocuments: contentTypes.relies_on_documents,
            isRequired: contentTypes.is_required,
            limit_visibility_types: contentTypes.limit_visibility_types,
            // subCategory: {
            //   name: subCategory.name,
            //   type: subCategory.type,
            //   code: subCategory.code,
            // },
            // category: {
            //   name: category.name,
            //   type: category.type,
            //   code: category.code,
            // },
          });
        });
      });
    });

    this.setState({
      etmfSchema: result,
      isLoading: false,
    });
  };

  downloadSchema = async () => {
    try {
      this.setState(() => ({
        loadingSchema: true,
      }));

      let data = null;

      const response = await etmfDocumentSchemaDownload();
      data = response.data;

      const blob = new Blob([data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `etmf-document-schema.csv`;
      link.click();
    } catch (e) {
      message.error("Error");
      console.log(e);
    }

    this.setState(() => ({
      loadingSchema: false,
    }));
  };

  render() {
    const { etmfSchema, isLoading } = this.state;

    const columns = [
      {
        dataIndex: "category.code",
        key: "category.code",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Primary Category code"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "category.name",
        key: "category.name",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Primary Category Name"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "subCategory.code",
        key: "subCategory.code",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Sub category code"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "subCategory.name",
        key: "subCategory.name",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Sub category name"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "code",
        key: "code",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Content Type code"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("NamespaceDocumentsEditor:Content Type Name"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "type",
        key: "type",
        width: 200,
        title: this.props.i18n.t("NamespaceDocumentsEditor:Term type"),
        render: (val) => {
          return <span>{val}</span>;
        },
      },
      {
        dataIndex: "isRequired",
        key: "isRequired",
        width: 100,
        title: this.props.i18n.t("Is required"),
        render: (val) => {
          return (
            <span>
              {val && (
                <Icon type="check-square" className={classes.checkIcon} />
              )}
            </span>
          );
        },
      },
      {
        dataIndex: "reliesOnDocuments",
        key: "reliesOnDocuments",
        width: 150,
        title: this.props.i18n.t("NamespaceDocumentsEditor:Relies on documents"),
        render: (val) => {
          return (
            <div>
              {map(val, (relyId) => {
                return (
                  <div>
                    {get(
                      find(etmfSchema, ({ code }) => code === relyId),
                      "name"
                    )}
                  </div>
                );
              })}
            </div>
          );
        },
      },
      {
        dataIndex: "limit_visibility_types",
        key: "limit_visibility_types",
        width: 200,
        title: this.props.i18n.t("NamespaceDocumentsEditor:Limit visibility types"),
        render: (val) => {
          return (
            <div>
              {map(val, (item) => {
                return (
                  <div>
                    {item.replace(/_/g, ' ')}
                  </div>
                );
              })}
            </div>
          );
        },
      },
    ];

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t(
                "NamespaceDocumentsEditor:Document eTMF Schema Admin"
              )}
            </h3>

            <div className={classes.actionWrapper}>
              {this.props.createEtmfDocument && (
                <Button
                  type="primary"
                  onClick={() => {
                    this.setState({ isUploadModalOpen: true });
                  }}
                  style={{ marginRight: "20px" }}
                >
                  {this.props.i18n.t("NamespaceDocumentsEditor:Update eTMF Schema")}
                </Button>
              )}
              <Button
                onClick={() => this.downloadSchema()}
                disabled={this.state.loadingSchema}
                loading={this.state.loadingSchema}
                type="primary"
              >
                {this.props.i18n.t("NamespaceDocumentsEditor:Download eTMF Schema")}
              </Button>
            </div>

            <div className={classes.tableWrapper}>
              <Table
                columns={columns}
                dataSource={etmfSchema}
                loading={isLoading}
                rowKey="id"
                pagination={false}
                // onChange={this.handleTableChange}
              />
            </div>
          </Content>
        </Layout>

        <Modal
          visible={this.state.isUploadModalOpen}
          onCancel={() => {
            this.setState({ isUploadModalOpen: false });
          }}
          footer={null}
        >
          {this.state.isUploadModalOpen && (
            <DocumentEtmfSchemaUpload
              onSubmit={() => {
                this.etmfDocumentSchemaGet();
                this.setState({ isUploadModalOpen: false });
              }}
              onCancel={() => {
                this.setState({ isUploadModalOpen: false });
              }}
            />
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  createEtmfDocument: getCreateEtmfDocument(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentsEtmfSchema))
);


// WEBPACK FOOTER //
// ./src/containers/DocumentsEtmfSchema/DocumentsEtmfSchema.js